// Mapa de colores para JRF Sportswear
// Asocia nombres de color en español a sus valores hexadecimales
// Fallback inteligente al final: si un color no está en el mapa,
// intenta detectar la familia por palabra clave (verde/rojo/azul/etc.)

export const COLOR_MAP = {
  // ===== Blancos =====
  'Blanca': '#FFFFFF',
  'Blanco': '#FFFFFF',
  'Blanco Perla': '#F8F6F0',
  'Blanco Roto': '#F5F1E8',
  'Blanco Hueso': '#F5F0E1',
  'Blanco Marfil': '#FFFFF0',
  'Blanco Logo Negro': '#FFFFFF',
  'Blanco Logo Beige': '#FFFFFF',
  'Marfil': '#FFFFF0',
  'Nieve': '#FAFAFA',

  // ===== Negros =====
  'Negra': '#1a1a1a',
  'Negro': '#1a1a1a',
  'Negro Ónix': '#0F0F0F',
  'Negro Onix': '#0F0F0F',
  'Negro Azabache': '#0A0A0A',
  'Negra Logo Negro': '#1a1a1a',
  'Negra Logo Blanco': '#1a1a1a',
  'Negro Logo Blanco': '#1a1a1a',
  'Negro Logo Beige': '#1a1a1a',

  // ===== Grises =====
  'Gris': '#6B7280',
  'Gris Claro': '#D1D5DB',
  'Gris Perla': '#C8C8C8',
  'Gris Medio': '#808080',
  'Gris Oscuro': '#374151',
  'Gris Grafito': '#4B5563',
  'Gris Antracita': '#3D3D3D',
  'Gris Plomo': '#5C5C5C',
  'Grafito': '#4B5563',
  'Antracita': '#3D3D3D',
  'Plata': '#C0C0C0',
  'Plateado': '#C0C0C0',
  'Piedra': '#8B8680',
  'Topo': '#8B7D6B',

  // ===== Cremas y Beiges =====
  'Crema-Beige': '#F5F5DC',
  'Crema Elegante': '#FAF0E6',
  'Crema': '#F5F5DC',
  'Beige': '#D4B896',
  'Beige Logo Beige': '#D4B896',
  'Beige Logo Blanco': '#D4B896',
  'Beige Logo Negro': '#D4B896',
  'Arena': '#E8D5A9',
  'Nude': '#E8C5A0',
  'Champagne': '#F7E7CE',
  'Champán': '#F7E7CE',
  'Camel': '#C19A6B',
  'Camello': '#C19A6B',
  'Tostado': '#B08D57',
  'Taupe': '#8B7D6B',
  'Sepia': '#704214',

  // ===== Azules =====
  'Azul': '#2563EB',
  'Azul Marino': '#1E3A5F',
  'Marino': '#1E3A5F',
  'Azul Noche': '#0F1E3F',
  'Azul Oscuro': '#1E3A8A',
  'Azul Petróleo': '#1F3B4D',
  'Azul Petroleo': '#1F3B4D',
  'Azul Eléctrico': '#0070FF',
  'Azul Electrico': '#0070FF',
  'Azul Rey': '#1E40AF',
  'Azul Cielo': '#7EC8E3',
  'Azul Claro': '#93C5FD',
  'Azul Pastel': '#B8D4E3',
  'Azul Insignia': '#3B82F6',
  'Azul Grisáceo': '#64748B',
  'Azul Grisaceo': '#64748B',
  'Azul Denim': '#4A6FA5',
  'Denim': '#4A6FA5',
  'Cobalto': '#0047AB',
  'Turquesa': '#06B6D4',
  'Aguamarina': '#7FDBDA',
  'Cian': '#00BCD4',
  'Índigo': '#4B0082',
  'Indigo': '#4B0082',
  'Zafiro': '#0F52BA',

  // ===== Rosas =====
  'Rosa': '#EC4899',
  'Rosa Claro': '#FBCFE8',
  'Rosa Pastel': '#F9C6D2',
  'Rosa Palo': '#F0BFC0',
  'Rosa Chicle': '#FF77A9',
  'Rosa Fucsia': '#E91E63',
  'Rosa Melocotón': '#FBBF94',
  'Rosa Nude': '#EAB8B4',
  'Melocotón Pink': '#FBBF94',
  'Melocotón': '#FBBF94',
  'Melocoton': '#FBBF94',
  'Fucsia': '#E91E63',
  'Salmón': '#FA8072',
  'Salmon': '#FA8072',

  // ===== Amarillos =====
  'Amarillo': '#FACC15',
  'Amarillo Pastel': '#F7E7A0',
  'Amarillo Claro': '#FFF59D',
  'Amarillo Mostaza': '#D4A017',
  'Mostaza': '#D4A017',
  'Amarillo Dorado': '#FFC300',
  'Dorado': '#DAA520',
  'Oro': '#FFD700',
  'Ocre': '#CC7722',

  // ===== Morados / Púrpura =====
  'Púrpura': '#6B4A8C',
  'Purpura': '#6B4A8C',
  'Morado': '#7C3AED',
  'Violeta': '#8B5CF6',
  'Lila': '#B39DDB',
  'Lavanda': '#C9A0DC',
  'Malva': '#B285BC',
  'Berenjena': '#5A2A5A',
  'Ciruela': '#8B4B7F',

  // ===== Verdes =====
  'Verde': '#059669',
  'Verde Bosque': '#2F4F3F',
  'Verde Oliva': '#556B2F',
  'Oliva': '#556B2F',
  'Verde Militar': '#4B5320',
  'Militar': '#4B5320',
  'Verde Caqui': '#8B8B4E',
  'Verde Menta': '#98D8C8',
  'Menta': '#98D8C8',
  'Verde Lima': '#A4C400',
  'Lima': '#A4C400',
  'Verde Salvia': '#9CAF88',
  'Salvia': '#9CAF88',
  'Verde Esmeralda': '#00A86B',
  'Esmeralda': '#00A86B',
  'Verde Pistacho': '#93C572',
  'Pistacho': '#93C572',
  'Verde Botella': '#006A4E',
  'Verde Manzana': '#8DB600',
  'Verde Neón': '#39FF14',
  'Verde Neon': '#39FF14',
  'Jade': '#00A86B',

  // ===== Naranjas =====
  'Naranja': '#F97316',
  'Naranja Neón': '#FF6600',
  'Naranja Neon': '#FF6600',
  'Naranja Quemado': '#CC5500',
  'Terracota': '#C87456',
  'Teja': '#B8593A',
  'Cobre': '#B87333',
  'Bronce': '#CD7F32',
  'Óxido': '#B7410E',
  'Oxido': '#B7410E',

  // ===== Corales =====
  'Coral': '#F97362',
  'Coral Suave': '#F5A79A',

  // ===== Rojos =====
  'Rojo': '#DC2626',
  'Rojo Cereza': '#DC2626',
  'Rojo Cerezo': '#DC2626',
  'Rojo Sangre': '#8B0000',
  'Rojo Fuego': '#E63946',
  'Rojo Escarlata': '#FF2400',
  'Escarlata': '#FF2400',
  'Cereza': '#B22222',
  'Vino': '#722F37',
  'Vino Tinto': '#5E1F26',
  'Burdeos': '#7B2C3F',
  'Granate': '#800020',
  'Bermellón': '#E34234',
  'Bermellon': '#E34234',
  'Pomelo': '#FB7185',

  // ===== Marrones y Tierra =====
  'Marrón': '#8B4513',
  'Marron': '#8B4513',
  'Marrón Caqui': '#A0826D',
  'Marrón Tierra': '#8B5E3C',
  'Marrón Oscuro': '#4A2C20',
  'Marrón Claro': '#A67B5B',
  'Marrón Chocolate': '#3E2723',
  'Chocolate': '#3E2723',
  'Caqui': '#8B8B4E',
  'Café': '#6F4E37',
  'Cafe': '#6F4E37',
  'Canela': '#A0522D',
  'Cacao': '#4B2E1D',
  'Tierra': '#8B5E3C',
  'Nogal': '#5B3924',
  'Caoba': '#6A2E1F',

  // ===== Otros =====
  'Color único': '#9CA3AF',
  'Única': '#9CA3AF',
  'Unica': '#9CA3AF',
  'Multicolor': 'linear-gradient(90deg,#EC4899,#F59E0B,#10B981,#3B82F6)',
  'Estampado': '#9CA3AF',
  'Neutro': '#B0A896',
};

// Normaliza un nombre de color: minúsculas, sin acentos, sin guiones
const normalize = (str) => {
  if (!str) return '';
  return str
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // quitar acentos
    .toLowerCase()
    .replace(/[-_\s]+/g, ' ')
    .trim();
};

// Mapa normalizado para búsqueda insensible a mayúsculas/acentos
const NORMALIZED_MAP = Object.entries(COLOR_MAP).reduce((acc, [key, value]) => {
  acc[normalize(key)] = value;
  return acc;
}, {});

// Fallback inteligente: si el nombre completo no está, intenta detectar familia por palabra clave
const FAMILY_FALLBACK = [
  { keywords: ['blanc', 'marfil', 'nieve', 'perla', 'crudo'], hex: '#F5F1E8' },
  { keywords: ['negr', 'onix', 'azabache'], hex: '#1a1a1a' },
  { keywords: ['gris', 'gray', 'grafito', 'antracita', 'plomo', 'plata'], hex: '#6B7280' },
  { keywords: ['crema', 'beige', 'arena', 'nude', 'champa', 'camel', 'camello', 'tostado', 'taupe'], hex: '#D4B896' },
  { keywords: ['azul', 'marino', 'cobalto', 'zafiro', 'denim', 'indigo', 'petroleo'], hex: '#2563EB' },
  { keywords: ['turques', 'aguamarina', 'cian'], hex: '#06B6D4' },
  { keywords: ['rosa', 'fucsia', 'salmon', 'salmón', 'chicle', 'palo'], hex: '#EC4899' },
  { keywords: ['melocot', 'peach'], hex: '#FBBF94' },
  { keywords: ['amaril', 'mostaza', 'dorad', 'oro', 'yellow', 'ocre'], hex: '#FACC15' },
  { keywords: ['morad', 'purpur', 'violeta', 'lila', 'lavanda', 'malva', 'berenjena', 'ciruela'], hex: '#7C3AED' },
  { keywords: ['verde', 'oliva', 'militar', 'menta', 'lima', 'salvia', 'esmeralda', 'pistacho', 'jade', 'green'], hex: '#059669' },
  { keywords: ['naranj', 'terracota', 'teja', 'cobre', 'bronce', 'oxido', 'orange'], hex: '#F97316' },
  { keywords: ['coral'], hex: '#F97362' },
  { keywords: ['vino', 'burdeos', 'granate', 'bermell'], hex: '#722F37' },
  { keywords: ['rojo', 'roja', 'cereza', 'escarlata', 'red', 'sangre', 'fuego'], hex: '#DC2626' },
  { keywords: ['marron', 'marrón', 'chocolate', 'caqui', 'cafe', 'canela', 'cacao', 'nogal', 'caoba', 'tierra', 'brown', 'sepia'], hex: '#8B4513' },
];

// Lista normalizada de colores claros (para dibujar borde en el swatch)
const LIGHT_COLORS_NORMALIZED = [
  'Blanca', 'Blanco', 'Blanco Perla', 'Blanco Roto', 'Blanco Hueso', 'Blanco Marfil',
  'Blanco Logo Negro', 'Blanco Logo Beige', 'Marfil', 'Nieve',
  'Crema', 'Crema-Beige', 'Crema Elegante', 'Champagne', 'Champán',
  'Beige', 'Beige Logo Beige', 'Beige Logo Blanco', 'Beige Logo Negro', 'Arena', 'Nude',
  'Amarillo Pastel', 'Amarillo Claro',
  'Rosa Melocotón', 'Melocotón Pink', 'Melocotón', 'Rosa Claro', 'Rosa Pastel', 'Rosa Palo',
  'Azul Claro', 'Azul Pastel', 'Azul Cielo', 'Aguamarina',
  'Gris Claro', 'Gris Perla', 'Plata',
  'Verde Menta', 'Menta', 'Verde Salvia', 'Salvia', 'Verde Pistacho', 'Pistacho',
  'Lavanda', 'Lila',
].map(normalize);

// Obtener hex del nombre de color (insensible a mayúsculas/acentos)
export const getColorHex = (colorName) => {
  if (!colorName) return '#9CA3AF';
  const n = normalize(colorName);
  if (NORMALIZED_MAP[n]) return NORMALIZED_MAP[n];
  // Fallback por familia
  for (const family of FAMILY_FALLBACK) {
    if (family.keywords.some((k) => n.includes(k))) {
      return family.hex;
    }
  }
  return '#9CA3AF';
};

// Verificar si el color es claro (para contraste de texto y borde del swatch)
export const isLightColor = (colorName) => {
  if (!colorName) return false;
  const n = normalize(colorName);
  if (LIGHT_COLORS_NORMALIZED.includes(n)) return true;
  // Fallback aproximado a partir del hex
  const hex = getColorHex(colorName);
  if (typeof hex !== 'string' || !hex.startsWith('#') || hex.length < 7) return false;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.75;
};

// Estilos para el swatch de color
export const getSwatchStyle = (colorName) => {
  const hex = getColorHex(colorName);
  const isLight = isLightColor(colorName);

  return {
    backgroundColor: hex,
    border: isLight ? '1px solid #D1D5DB' : 'none',
  };
};
